"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = exports.baseAxiosConfig = exports.baseAuthConfig = void 0;
exports.baseAuthConfig = {
    domain: 'idp.monk.ai',
    audience: 'https://api.monk.ai/v1/',
    clientId: '',
};
exports.baseAxiosConfig = {
    baseURL: 'https://api.monk.ai/v1/',
    headers: { 'Access-Control-Allow-Origin': '*' },
};
/**
 * The corejs configuration object.
 */
var Config = /** @class */ (function () {
    function Config(_axiosConfig, _authConfig, _packageVersions) {
        if (_axiosConfig === void 0) { _axiosConfig = exports.baseAxiosConfig; }
        if (_authConfig === void 0) { _authConfig = exports.baseAuthConfig; }
        if (_packageVersions === void 0) { _packageVersions = {}; }
        this._axiosConfig = _axiosConfig;
        this._authConfig = _authConfig;
        this._packageVersions = _packageVersions;
    }
    Object.defineProperty(Config.prototype, "authConfig", {
        get: function () {
            return this._authConfig;
        },
        set: function (value) {
            this._authConfig = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Config.prototype, "axiosConfig", {
        get: function () {
            return this._axiosConfig;
        },
        set: function (value) {
            this._axiosConfig = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Config.prototype, "accessToken", {
        get: function () {
            var _a, _b;
            return (_b = (_a = this.axiosConfig.headers) === null || _a === void 0 ? void 0 : _a.Authorization) === null || _b === void 0 ? void 0 : _b.toString();
        },
        set: function (value) {
            this._axiosConfig = __assign(__assign({}, this.axiosConfig), { headers: __assign(__assign({}, this.axiosConfig.headers), { Authorization: "Bearer ".concat(value.replace('Bearer ', '')) }) });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Config.prototype, "packageVersions", {
        get: function () {
            return this._packageVersions;
        },
        set: function (value) {
            this._packageVersions = value;
        },
        enumerable: false,
        configurable: true
    });
    Config.prototype.toPlainObject = function () {
        return {
            authConfig: this.authConfig,
            axiosConfig: this.axiosConfig,
        };
    };
    return Config;
}());
exports.Config = Config;
exports.default = new Config();
//# sourceMappingURL=config.js.map